import { atom } from "jotai";
import { Call } from "voximplant-websdk/Call/Call";

export const callInfo = atom<Call | null>(null);
